import styled from "styled-components";

export const BackupUserContainer = styled.div`
  height: 100%;
`;

export const BackupContainer = styled.div`
  height: 100%;
`;

export const ContentsBody = styled.div`
  background-color: white;
  border-radius: 1.2rem;
  height: calc(100% - 6rem);
  padding: 3rem;
  overflow: hidden scroll;
  position: relative;
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 3rem;
    .total {
      font-size: 1.6rem;
      color: #555;
      font-weight: 500;
    }
    .sort {
      .search-select {
        font-size: 1.4rem;
      }
    }
  }

  .top-contents {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 3rem;
    .total {
      margin-bottom: 0;
    }
    .btn-box {
      display: flex;
      gap: 16px;
      button {
        min-width: 15.4rem;
        font-size: 1.6rem;
        font-weight: 400;
        letter-spacing: -0.05rem;
        color: white;
        border: none;
        outline: none;
        border-radius: 0.6rem;
        padding: 1rem;
        opacity: 0.6;

        &.regist {
          background-color: #30a690;
        }
        &.modify {
          background-color: #2d2d2d;
        }
        &.delete {
          background-color: #ffab40;
        }
        &:hover {
          opacity: 1;
        }
        &:active {
          transform: scale(0.97);
        }
      }
    }
  }
  .top-components {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 3rem;
    .l {
      display: flex;
      align-items: center;
      gap: 0.8rem;
      label {
        font-size: 1.6rem;
        font-weight: 400;
        color: #555;
        transform: translateY(1px);
      }
      input {
        width: 1.6rem;
        height: 1.6rem;
      }
    }
    .r {
      button {
        width: 15.4rem;
        height: 3.6rem;
        display: flex;
        align-items: center;
        justify-content: center;
        outline: none;
        border: 0;
        background-color: #ffab40;
        color: white;
        font-size: 1.6rem;
        line-height: 1;
        letter-spacing: -0.05rem;
        border-radius: 0.6rem;
        opacity: 0.6;
        &:active {
          transform: scale(0.97);
        }
        &:hover {
          opacity: 1;
        }
        &:disabled {
          transform: scale(1);
          background-color: #eee;
          color: #555;
          opacity: 1;
        }
      }
    }
  }
  .hr {
    height: 2px;
    background-color: #ebebeb;
    width: calc(100% + 6rem);
    margin: 0 -3rem;
  }
  .loading,
  .no-data {
    padding: 2rem;
    text-align: center;
    font-size: 1.6rem;
    border: 1px solid #ececec;
    border-radius: 0.6rem;
  }
  @media screen and (max-width: 768px) {
    padding: 1.6rem;
    height: auto;
    .top-components {
      margin-bottom: 1.6rem;
      .r {
        button {
          width: 7rem;
        }
      }
    }
  }
`;

export const ImageFileListContainer = styled.div`
  .contents-top {
    border: 1px solid #30a690;
    border-radius: 1.2rem;
    overflow: hidden;
    display: flex;
    height: 8rem;
    align-items: stretch;
    margin-bottom: 2.4rem;
    .device-name {
      min-width: 40rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #30a690;
      p {
        color: white;
        font-size: 2.4rem;
        font-weight: bold;
        letter-spacing: -0.05rem;
        line-height: 1.5;
      }
    }
    .device-info {
      display: flex;
      padding: 2.4rem 3.6rem;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      p {
        font-size: 1.6rem;
        line-height: 1.5;
        letter-spacing: -0.05rem;
        color: #555;
        font-weight: 500;
      }
      .user-info {
        padding: 0.8rem 1.6rem;
        display: flex;
        gap: 0.8rem;
        border-radius: 0.6rem;
        background-color: #ebebeb;
        span {
          font-size: 1.4rem;
          color: #6d6d6d;
        }
      }
    }
  }
  .file-list-container {
    background-color: white;
    border-radius: 1.2rem;
    overflow: hidden;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #ebebeb;
      padding: 2.6rem 3.6rem;
      .path-name {
        font-size: 2.2rem;
        font-weight: bold;
      }
      .right {
        display: flex;
        align-items: center;
        .search-select {
          font-size: 1.4rem;
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    .contents-top {
      flex-direction: column;
      height: auto;
      .device-name {
        padding: 2rem 0;
        p {
          font-size: 2rem;
        }
      }
      .device-info {
        flex-direction: column;
        gap: 1.2rem;
        padding: 2rem 1rem;
        p {
          font-size: 1.4rem;
        }
        .user-info {
          flex-direction: column;
          width: 100%;
          align-items: center;
          gap: 1rem;
          span {
          }
          span:nth-child(even) {
            display: none;
          }
        }
      }
    }
    .file-list-container {
      .top {
        flex-direction: column;
        gap: 1rem;
        padding: 2rem 1rem;
        .path-name {
          font-size: 1.6rem;
          span {
            word-break: break-all;
          }
        }
        .right {
          width: 100%;
          > div {
            width: 100%;
            gap: 0.4rem;
            .l {
              .search-select {
              }
            }
            .r {
              width: 100%;
              gap: 0.4rem;
            }
          }
        }
      }
    }
  }
`;

export const TableContainer = styled.div`
  padding: 3.2rem 3.6rem;
  .loading {
    text-align: center;
    font-size: 1.6rem;
    padding: 1.6rem;
    border: 1px solid #ebebeb;
    border-radius: 1.2rem;
  }
  .table-head-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 2rem;
    .left {
      .table-total-row {
        display: flex;
        align-items: center;
        font-size: 1.6rem;
        color: #555;
        font-weight: 500;
        input[type="checkbox"] {
          width: 1.6rem;
          height: 1.6rem;
        }
      }
    }
    .right {
      .btn-box {
        &.multi {
          display: flex;
          gap: 1.6rem;
          button {
            width: 15.4rem;
          }
        }
        button {
          background-color: #0e322b;
          padding: 1rem 2.4rem;
          color: white;
          border-radius: 0.6rem;
          font-size: 1.6rem;
          font-weight: 500;
          border: none;
          outline: none;
          cursor: pointer;
          opacity: 0.7;

          &:hover {
            opacity: 1;
          }
          &:active {
            transform: scale(0.98);
          }
          &.regist {
            background-color: #30a690;
          }
          &.modify {
            background-color: #2d2d2d;
          }
          &.delete {
            background-color: #ffab40;
          }
        }
      }
    }
  }
  .fixed-height {
    max-height: 55rem;
    overflow-x: auto;
  }
  table {
    width: 100%;
    thead {
      th {
        font-size: 1.5rem;
        color: #2d2d2d;
        background-color: #c1e4de;
        padding: 1.6rem;
        border-bottom: none;
        position: relative;
        span.up {
          display: inline-flex;
          margin-left: 1rem;
          transform: rotate(90deg) translateX(2px);
          img {
            display: flex;
            width: 0.8rem;
          }
        }
        span.down {
          display: inline-flex;
          margin-left: 1rem;
          transform: rotate(270deg) translateX(-2px);
          img {
            display: flex;
            width: 0.8rem;
          }
        }
      }
    }
    th,
    td {
      border-left: 1px solid #ebebeb;
      border-bottom: 1px solid #ebebeb;
    }
    th:first-child,
    td:first-child {
      border-left: none;
    }
    tbody {
      td {
        font-size: 1.5rem;
        font-weight: 400;
        text-align: center;
        padding: 1.8rem;
        color: #555;
        vertical-align: middle;
        input[type="checkbox"] {
          width: 1.6rem;
          height: 1.6rem;
        }
        &.type-folder {
          color: #2d2d2d;
        }
        .clickable-folder {
          color: #1847ed;
          text-decoration: underline;
          cursor: pointer;
        }
        .download-btn {
          background-color: #0e322b;
          color: white;
          width: 15.4rem;
          padding: 0.9rem;
          border: none;
          outline: none;
          border-radius: 0.4rem;
          opacity: 0.7;
          &:hover {
            opacity: 1;
          }
          &:active {
            transform: scale(0.97);
          }
        }
        .folder-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 2rem;
            display: flex;
            transform: translateY(-2px);
          }
          gap: 0.4rem;
        }
      }
    }
  }
  @media screen and (max-width: 768px) {
    padding: 2rem 1rem;
    form {
      width: 100%;
      overflow: hidden;
      .fixed-height {
        width: 100%; /* 부모 요소의 너비를 100%로 설정 */
        overflow-x: auto !important;
        -webkit-overflow-scrolling: touch !important; /* 터치스크린에서 스크롤이 부드럽게 보이도록 설정 */

        table {
          min-width: 1400px;
          width: 100%;
        }
      }
      .table-head-wrap.user-table {
        flex-direction: column;
        .left {
          .table-total-row {
            margin-bottom: 1rem;
          }
        }
        .right {
          .btn-box.multi {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            button {
              width: auto;
            }
          }
        }
      }
    }
  }
`;

export const DownloadListContainer = styled.div`
  .contents-body {
    .user-select-info {
      background-color: white;
      border-radius: 1.2rem;

      display: flex;
      justify-content: space-between;
      align-items: center;
      form {
        display: flex;
        gap: 0.8rem;
        padding: 1.6rem 3.6rem;
        .select-contents {
          font-size: 1.6rem;
          min-width: 30rem;
        }
        .select-btn {
          border: none;
          outline: none;
          background-color: #30a690;
          color: white;
          font-size: 1.4rem;
          width: 12rem;
          border-radius: 0.6rem;
        }
      }
    }
    .btn-box {
      button {
        cursor: pointer;
        min-width: 15.4rem;
        font-size: 1.6rem;
        font-weight: 400;
        letter-spacing: -0.05rem;
        color: white;
        border: none;
        outline: none;
        border-radius: 0.6rem;
        padding: 1rem;
        opacity: 0.6;
        background-color: #ffab40;
        &:hover {
          opacity: 1;
        }
        &:active {
          transform: scale(0.98);
        }
      }
    }
    .download-list-box {
      background-color: white;
      border-radius: 1.2rem;
    }
  }
  @media screen and (max-width: 768px) {
    min-height: 80rem;
    .user-list-top-header {
      width: 100%;
      .l {
        .search-select {
        }
      }
      .r {
        width: 100%;
        gap: 0.4rem;
        > div {
          width: 100%;
          gap: 0.4rem;
          .l {
            .search-select {
            }
          }
          .r {
            width: 100%;
            gap: 0.4rem;
          }
        }
      }
    }
    .contents-body {
      .user-select-info {
        form {
          flex-direction: column;
          padding: 2rem;
          .select-contents {
            min-width: auto;
          }
          .select-btn {
            padding: 1rem;
            width: 100%;
          }
        }
      }
    }
  }
`;
